import axios from 'axios';
import Morphism from 'morphism';
import User from '../models/User';

export default class AuthService {
  /**
   * Authenticate with provided credentials
   * @param   {String} username
   * @param   {String} password
   * @returns {Promise<Object>}
   */
  static authenticate(username, password) {
    return new Promise((resolve, reject) => {
      axios.post('/oauth/token', {
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: 'password',
        username,
        password,
      }).then((response) => {
        resolve({
          accessToken: response.data.access_token,
          refreshToken: response.data.refresh_token,
        });
      }).catch(reject);
    });
  }

  /**
   * Get current user
   * @returns {Promise<User>}
   */
  static getUser() {
    return new Promise((resolve, reject) => {
      axios.get('/api/driver/current')
        .then((response) => {
          const schema = {
            id: 'id',
            username: 'username',
            firstname: 'firstname',
            lastname: 'lastname',
            canModifyEntries: 'can_modify_entries',
          };

          const user = Morphism(schema, response.data.data, User);

          resolve(user);
        }).catch(reject);
    });
  }

  /**
   * Refresh Access token, returns new access token & refresh token
   * @param {String} refreshToken
   * @returns {Promise<Object>}
   */
  static refreshToken(refreshToken) {
    return new Promise((resolve, reject) => {
      axios.post('/oauth/token', {
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      }).then((response) => {
        resolve({
          accessToken: response.data.access_token,
          refreshToken: response.data.refresh_token,
        });
      }).catch(reject);
    });
  }
}
